import { GET_CODE_REQUEST, GET_CODE_SUCCESS } from "../actionTypes";
import { REACT_APP_BACKEND_URL } from "@Constants/tokens";
import getAPI from "@API/index";

//fetch one code
export const getCodeRequest = () => {
  return {
    type: GET_CODE_REQUEST,
  };
};

const getCodeSuccess = (code) => {
  return {
    type: GET_CODE_SUCCESS,
    payload: code,
  };
};

export const getCode = (id) => {
  return (dispatch) => {
    dispatch(getCodeRequest());
    getAPI()
      .request({
        url: `${REACT_APP_BACKEND_URL()}/api/code/${id}`,
        method: "get",
        errorText: "snackbar.getCodeError",
        suppressError: true,
      })
      .then((data) => {
        dispatch(getCodeSuccess(data));
      });
  };
};
